module.exports = __webpack_public_path__ + "static/media/line2.21d1f793.png";